module.exports = __webpack_public_path__ + "img/3.32316727.png";